import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import Axios from 'axios';
import { placesElastic } from '../../constants/api';
import { PATH } from '../../envs/core';

const dataProvider = {};

export const getData = id => {
  if (dataProvider[id]) {
    return Promise.resolve(dataProvider[id]);
  }
  return Axios.get(`${PATH}${placesElastic}${id}`)
    .then(response => {
      return response.data;
    })
    .then(response => {
      dataProvider[id] = response;
      return response;
    });
};

export const SinglePlaceProvider = ({ id, children }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    getData(id).then(response => {
      setData(response.content);
    });
  }, [id]);

  return children(data);
};

SinglePlaceProvider.propTypes = {
  id: PropTypes.string.isRequired
};
